module.exports = __webpack_public_path__ + "img/shape-metal_ac-gold@2x.5a526d4e.png";